import hyperdom from 'hyperdom'
import ValidationBase from '../../validationBase.jsx'

export default class SectionComponentBase extends ValidationBase {
  constructor ({sectionName}) {
    super()
    this.sectionName = sectionName
    this.toggledForMobile
  }

  toggleSection () {
    this.opened = !this.opened
  }

  scrollToNextSection (currentSectionName) {
    let nextElement
    switch (currentSectionName) {
    case 'past-guest':
      nextElement = document.querySelector('.travel-protection')
      return nextElement ? nextElement.scrollIntoView({behavior: 'smooth', block: 'center'}) : this.scrollToNextSection('travel-protection')
    case 'travel-protection':
      nextElement = document.querySelector('.gratuities')
      return nextElement ? nextElement.scrollIntoView({behavior: 'smooth', block: 'center'}) : this.scrollToNextSection('prepaid-gratuities')
    case 'prepaid-gratuities':
      nextElement = document.querySelector('.special-requirements')
      return nextElement ? nextElement.scrollIntoView({behavior: 'smooth', block: 'center'}) : undefined
    default: return
    }
  }

  renderRadioButtons ({onNoClick, onYesClick} = {}) {
    return <div class={'u-padding-bottom-medium'}>
      <div class={['u-inbl', 'u-padding-right-large']}>
        <label class='o-choice-item'>
          <input name={`no-${this.sectionName}`} type='radio' class='o-choice-item__radio' binding={{
            get: () => this.toggledForMobile,
            set: (value) => {
              this.toggledForMobile = value
              onNoClick && onNoClick()
              this.scrollToNextSection(this.sectionName)
            },
          }} value={false} required />
          <div class='o-choice-item__content'>No</div>
        </label>
      </div>
      <div class="u-inbl">
        <label class='o-choice-item'>
          <input name={`yes-${this.sectionName}`} type='radio' class='o-choice-item__radio' binding={{
            get: () => this.toggledForMobile,
            set: (value) => {
              this.toggledForMobile = value
              onYesClick && onYesClick()
            },
          }} value={true} required />
          <div class={['o-choice-item__content']}>Yes</div>
        </label>
      </div>
    </div>
  }
}
